import _ from 'lodash';
import { Sorting } from './Sorting';
import { Filter } from './Filter';
import { Config } from './Config';

export class State {
  public sorting: Sorting[];
  public filters: Filter[];

  constructor(sorting: Sorting[], filters?: Filter[]) {
    this.sorting = sorting;
    this.filters = filters || [];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public sortAndFilterLocal(array: Array<any>, config: Config): Array<any> {
    array = this.filterLocal(array, config.permanentFilters);
    array = this.filterLocal(array, this.filters);
    array = this.sortLocal(array);
    return array;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public sortLocal(array: Array<any>): Array<any> {
    return _.orderBy(
      array,
      this.sorting.map((s) => s.sortBy),
      this.sorting.map((s) => (s.sortMode === 'descending' ? 'desc' : 'asc'))
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterLocal(array: Array<any>, filters: Array<Filter>): Array<any> {
    filters.forEach((filter) => {
      if (filter.filterType === 'equals') {
        array = array.filter((row) => {
          return this.filterEquals(row, filter);
        });
      } else if (filter.filterType === 'contains') {
        array = array.filter((row) => {
          return this.filterContains(row, filter);
        });
      } else if (filter.filterType === 'notequals') {
        array = array.filter((row) => {
          return this.filterNotEquals(row, filter);
        });
      } else if (filter.filterType === 'before') {
        array = array.filter((row) => {
          return this.filterBefore(row, filter);
        });
      } else if (filter.filterType === 'after') {
        array = array.filter((row) => {
          return this.filterAfter(row, filter);
        });
      } else if (filter.filterType === 'between') {
        array = array.filter((row) => {
          return this.filterBetween(row, filter);
        });
      } else {
        array = array.filter((row) => {
          return this.filterDefault(row, filter);
        });
      }
    });
    return array;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterEquals(row: any, filter: Filter) {
    let show = false;
    const field =
      row[filter.fieldName] !== undefined && row[filter.fieldName] !== null
        ? row[filter.fieldName]
        : '';
    filter.filterQuery.forEach((filterValue) => {
      if (field.toString().toLowerCase() === filterValue.toString().toLowerCase()) {
        show = true;
      }
    });
    return show;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterContains(row: any, filter: Filter) {
    let show = false;
    const field =
      row[filter.fieldName] !== undefined && row[filter.fieldName] !== null
        ? row[filter.fieldName]
        : '';
    filter.filterQuery.forEach((filterValue) => {
      if (field.toString().toLowerCase().includes(filterValue.toString().toLowerCase())) {
        show = true;
      }
    });
    return show;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterNotEquals(row: any, filter: Filter) {
    let show = false;
    const field =
      row[filter.fieldName] !== undefined && row[filter.fieldName] !== null
        ? row[filter.fieldName]
        : '';
    filter.filterQuery.forEach((filterValue) => {
      if (field.toString().toLowerCase() !== filterValue.toString().toLowerCase()) {
        show = true;
      }
    });
    return show;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterBefore(row: any, filter: Filter) {
    let show = false;
    const field =
      row[filter.fieldName] !== undefined && row[filter.fieldName] !== null
        ? row[filter.fieldName]
        : '';
    filter.filterQuery.forEach((filterValue) => {
      if (field <= filterValue) {
        show = true;
      }
    });
    return show;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterAfter(row: any, filter: Filter) {
    let show = false;
    const field =
      row[filter.fieldName] !== undefined && row[filter.fieldName] !== null
        ? row[filter.fieldName]
        : '';
    filter.filterQuery.forEach((filterValue) => {
      if (field >= filterValue) {
        show = true;
      }
    });
    return show;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterBetween(row: any, filter: Filter) {
    let show = false;
    const field =
      row[filter.fieldName] !== undefined && row[filter.fieldName] !== null
        ? row[filter.fieldName]
        : '';
    filter.filterQuery.forEach((filterValue) => {
      const filterParts = ('' + filterValue).split(',');
      if (field >= filterParts[0] && field <= filterParts[1]) {
        show = true;
      }
    });
    return show;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterDefault(row: any, filter: Filter) {
    let show = false;
    const field =
      row[filter.fieldName] !== undefined && row[filter.fieldName] !== null
        ? row[filter.fieldName]
        : '';
    filter.filterQuery.forEach((filterValue) => {
      if (field.toString().toLowerCase() === filterValue.toString().toLowerCase()) {
        show = true;
      }
    });
    return show;
  }
}
